module.exports = __webpack_public_path__ + "img/tight.86a14f31.png";